export class AppConstants {
    public static readonly ApplicationInsightsConfigurationName = 'applicationInsights'
    public static readonly ApplicationInsightsCloudRoleName = 'Pre-Supply Tour Frontend';
    public static readonly GrafanaConfigurationName = 'grafana';
    public static readonly AppName = 'PreSupplyTour';
}